export type PostReactionsProps = {
  postId: number
  reactions?: ReactionProps[]
  disabled?: boolean
  className?: string
  onReaction?: ({ reactionCode, count }: Omit<ReactionProps, 'reactedByUser'>) => void
  onReactionSuccess?: () => void
  onReactionError?: ({ statusCode, errorMessage }: OnReactionErrorParams) => void
}

export type ReactionProps = {
  reactionCode: ReactionCode | string
  count: number
  reactedByUser: boolean
}

export type ReactionListItem = ReactionProps & {
  reactionEmoji?: string | null
}

export type OnReactionErrorParams = {
  statusCode?: number
  errorMessage?: string
}

export enum ReactionCode {
  READ_HEART = '0x2764-0xfe0f',
  THUMBS_UP = '0x1f44d-0xfe0f',
  CLAPPING_HANDS = '0x1f44f-0xfe0f',
  FOLDED_HANDS = '0x1f64f-0xfe0f',
  PARTY_POPPER = '0x1f389-0xfe0f'
}
